import { MODES } from 'constants';
import get from 'lodash/get';
import has from 'lodash/has';
import includes from 'lodash/includes';
import toInteger from 'lodash/toInteger';
import features from 'lib/common/features';
import uniq from 'lodash/uniq';
import find from 'lodash/find';
import arrayWrap from 'lib/common/arrayWrap';

function filterPrices(prices, priceTypes) {
    if (!Array.isArray(priceTypes)) {
        priceTypes = [priceTypes];
    }

    return prices.filter(function(item) {
        return includes(priceTypes, toInteger(item.price_type))
    });
}

function determineFlexPriceTypes(
    prices,
    lineItems,
    currentCartItems,
    flexPriceTypes,
    subscriberAddOnPriceTypes
) {
    var currentFlexSeats = currentCartItems.filter(function(item) {
        return includes(flexPriceTypes, toInteger(item.price_type));
    });

    var selectedFlexSeats = lineItems.filter(function(item) {
        return includes(flexPriceTypes, toInteger(item.priceData.price_type));
    });

    if (selectedFlexSeats.length < currentFlexSeats.length) {
        return filterPrices(prices, flexPriceTypes);
    } else {
        return filterPrices(prices, subscriberAddOnPriceTypes);
    }
}

export default function filterByPriceTypes(mode, currentMOS, prices, priceTypes, currentCart, currentCartItems, lineItems) {
    var filterSettings = features.getOption('filterPriceTypes', 'options');
    var validModesOfSales = get(filterSettings, 'modesOfSale');
    var validPriceTypes = get(filterSettings, 'priceTypes');

    if (!(validModesOfSales && validPriceTypes)) {
        return prices;
    }

    /**
     * If in exchange MOS
     *     If price types belonging to items being returned are available
     *         Return the exchange price types
     *     Else find default price type from performance/package price type
     *         Return the default price type
     *     Else
     *         Return unfiltered all price types
     * In regular MOS
     *     Filter by provided list
     * In in subscriber MOS
     *     Performances: Show add on price type
     *     Fixed packages: Show fixed package price type
     *     Fixed package performances: Locked fixed package price type, show add on price type
     *     Flex package performances: For the no. of items in your cart show flex price type, then add on price type
     * If in any other MOS
     *     Return unfiltered prices
     */
    if (has(validModesOfSales, 'exchange') && validModesOfSales.exchange.indexOf(currentMOS) !== -1) {
        var currentSubLineItems = arrayWrap(currentCart.SubLineItem);

        var itemsBeingExchanged = currentSubLineItems.filter(lineItem => {
            return has(lineItem, 'ret_parent_sli_no');
        });

        var exchangePriceTypes = itemsBeingExchanged.map(lineItem => {
            return parseInt(lineItem.price_type, 10);
        });

        var filteredPrices = filterPrices(
            prices,
            uniq(exchangePriceTypes)
        );

        if (filteredPrices.length) {
            return filteredPrices;
        }

        var defaultPriceType = find(priceTypes, function (priceType) {
            return get(priceType, 'def_price_type', 'N') === 'Y';
        });

        if (defaultPriceType !== undefined) {
            var defaultPrices = filterPrices(
                prices,
                parseInt(defaultPriceType.price_type, 10)
            );

            if (defaultPrices.length) {
                return defaultPrices;
            }
        }

        return prices;
    } else if (mode === MODES.PERFORMANCE && currentMOS === validModesOfSales.regular && validPriceTypes.regular.length) {
        return filterPrices(
            prices,
            validPriceTypes.regular
        );
    } else if (mode === MODES.PERFORMANCE && currentMOS == validModesOfSales.subscriber && validPriceTypes.subscriberAddOn) {
        return filterPrices(
            prices,
            validPriceTypes.subscriberAddOn
        );
    } else if (mode === MODES.FIXED_PACKAGE && currentMOS == validModesOfSales.subscriber && validPriceTypes.fixedPackages.length) {
        return filterPrices(
            prices,
            validPriceTypes.fixedPackages
        );
    } else if (mode == MODES.FIXED_PACKAGE_PERFORMANCE && currentMOS === validModesOfSales.subscriber && validPriceTypes.subscriberAddOn.length) {
        return filterPrices(
            prices,
            validPriceTypes.subscriberAddOn
        );
    } else if (mode === MODES.FLEX_PACKAGE_PERFORMANCE && currentMOS === validModesOfSales.subscriber && validPriceTypes.flexPackages.length) {
        return determineFlexPriceTypes(
            prices,
            lineItems,
            currentCartItems,
            validPriceTypes.flexPackages,
            validPriceTypes.subscriberAddOn
        );
    } else {
        return prices;
    }
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/pricing/filterByPriceTypes.js